import {UnitOfMeasure} from 'app/blocks/model/unit-of-measure.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {IUnitOfMeasure} from 'app/blocks/model/unit-of-measure.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class UnitOfMeasureService extends EntityCrudService<IUnitOfMeasure> {
    constructor(http: HttpClient) {
        super(http, Resource.UNIT_OF_MEASURES, (obj?) => new UnitOfMeasure(obj));
    }
}
